import { useState } from "react";
import {
	Typography,
	List,
	ListItem,
	ListItemText,
	Collapse,
	makeStyles,
	IconButton,
} from "@material-ui/core";
import { Link } from "react-router-dom";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";

const useStyles = makeStyles((theme) => ({
	mainLink: {
		flex: "1 1 auto",
		minWidth: 0,
		margin: "4px 0",
		textDecoration: "none",
		color: theme.palette.text.primary,
	},
	nested: {
		paddingLeft: theme.spacing(4),
	},
	subLink: {
		paddingLeft: theme.spacing(6),
	}
}));

function MenuDrawerItem({ mainLink }) {
	const classes = useStyles();
	const [open, setOpen] = useState(false);

	const handleClick = (e) => {
		setOpen(!open);
	};

	if (mainLink.children.length > 0) {
		return (
			<>
				<ListItem button>
					<Typography
						className={classes.mainLink}
						component={Link}
						to={mainLink.url}
					>
						{mainLink.title}
					</Typography>
					{open ? (
						<IconButton size="small" onClick={handleClick}>
							<ExpandLess />
						</IconButton>
					) : (
						<IconButton size="small" onClick={handleClick}>
							<ExpandMore />
						</IconButton>
					)}
				</ListItem>
				<Collapse in={open} timeout="auto" unmountOnExit>
					<List component="div" disablePadding>
						{mainLink.children.map((child, i) => (
							<ListItem
								key={i}
								button
								component={Link}
								to={child.url}
								className={`${classes.nested} ${child.isSubLink && classes.subLink}`}
							>
								<ListItemText primary={child.title} />
							</ListItem>
						))}
					</List>
				</Collapse>
			</>
		);
	} else {
		return (
			<ListItem component={Link} to={mainLink.url} button>
				<ListItemText primary={mainLink.title} />
			</ListItem>
		);
	}
}

export default MenuDrawerItem;
